// Deals with Bonus Cash, Cash Back, + bonus cash, all that nonsense
import langFromUrl from 'lib/util/langFromUrl';
import tdaConfig from 'lib/util/tda.config';

const __lang = langFromUrl();

export function buildTitleContrived(offerObj, offerCardFromOat) {
  const {
    id,
    offerType,
    offerTypeTitle,
    miscellaneous
  } = offerObj;

  let type;

  if (miscellaneous && miscellaneous.label) {
    type = miscellaneous.label;
  } else {
    type = offerTypeTitle;
  }

  // default
  let title = `<span class="${offerType}-color">${type}</span> `;

  // totally custom
  if (BATSiteConfig.customOffers && BATSiteConfig.customOffers[id]) {
    title = `${BATSiteConfig.customOffers[id][__lang]}`;

    return title;
  }

  // New default (JSDS-180, new field in OAT)
  if (!title && offerCardFromOat.primaryOfferCardLabel) {
    title = `<span class="${offerType}-color">${offerCardFromOat.primaryOfferCardLabel}</span> `;
  }

  // New way to generate bonus text (JSDS-180, new field in OAT)
  if (offerCardFromOat.secondaryOfferCardLabel) {
    title += `<span class="plus">+</span> <span class="bonus-cash-color">${offerCardFromOat.secondaryOfferCardLabel}</span>`;
  }

  return title;
}

export function buildExtrasContrived(offerObj, offerCardFromOat) {
  const { extraCashAmount, extraCashLabel } = offerObj;

  let title = `+<sup class="dollar">$</sup>${extraCashAmount} `;

  if (extraCashLabel) {
    title += `<span class="extra-custom">${extraCashLabel}</span>`;
  } else if (offerCardFromOat.secondaryOfferCardLabel) {
    title += `${offerCardFromOat.secondaryOfferCardLabel}`;
  }
  return title;
}

export function buildExtrasContrivedInline(offerObj, offerCardFromOat) {
  const { extraCashAmount, extraCashLabel } = offerObj;

  let title = `<div class="number">+<sup class="dollar">$</sup>${extraCashAmount}</div>`;

  if (extraCashLabel) {
    title += `<div class="label">${extraCashLabel}</div>`;
  } else if (offerCardFromOat.secondaryOfferCardLabel) {
    title += `<div class="label">${offerCardFromOat.secondaryOfferCardLabel}</div>`;
  }

  return title;
}
